import { TailSpin } from "react-loader-spinner";

const Loading = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "80vh",
    }}
  >
    <TailSpin height="80" width="80" color="#4fa94d" ariaLabel="loading" />
  </div>
);
export default Loading;
